import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
//import { CadenasService } from 'src/app/aplicaciones-modulos/presupuesto-sellout/services/cadenas.service';
//import { CatalogoCadenasService } from 'src/app/aplicaciones-modulos/presupuesto-sellout/services/catalogo-cadenas.service';
import { CommonFormService } from 'src/app/shared/utils/common-form.service';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { indicadoresVivosModulo } from '../../diccionarios/indicadoresVivosModulo';
import { IndicadoresVivosVModel, IndicadoresVivosVModelInterface } from '../../models/indicadoresVivosVModel';
import { CatalogoIndicadoresService } from '../../services/catalogo-indicadores.service';
import { DireccionesService } from '../../services/direcciones.service';
import { IndicadoresVivosService } from '../../services/indicadores-vivos.service';

@Component({
  selector: 'app-mantenedor-direcciones',
  templateUrl: './mantenedor-direcciones.component.html',
  styleUrls: ['./mantenedor-direcciones.component.css']
})
export class MantenedorDireccionesComponent implements OnInit {

  tituloCard: string = 'Mantenedor Modelo de Negocio';
  tituloForm: string = 'Lista De Modelo de Negocio';

  formulario: FormGroup;

  mostrarFormulario: boolean = false;
  editableForm: boolean = false;

  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  columnDefs: any[];
  rowSelection: any;
  textoBuscar: string;

  //componentes para apuntar a diccionario
  DAT_BTNS;
  DAT_MSG;
  DAT_BTNCSS;

  textBoton: string;

  //para cargar con el grid
  listaVacia: boolean = true;
  loading: boolean = false;
  modulo: any = {};
  GUARDAR: string = 'guardar';

  constructor(
    private fb: FormBuilder,
    private commonFormService: CommonFormService,
    private _utils: UtilsService,
    private _direcciones: DireccionesService
  ) { }

  ngOnInit() {
    this.modulo = indicadoresVivosModulo;
    this.DAT_BTNS = this.modulo.button.buttonsNombre;
    this.DAT_MSG = this.modulo.mensajes;
    this.DAT_BTNCSS = this.modulo.button.buttonsCss;
    this.formulario = this.fb.group({
      codigo: ['', [Validators.required]],
      descripcion: ['', [Validators.required]]
    });
    this.cargarGridcomponent();
    this.getDirecciones();
  }

  /* FUNCIONES */
  cargarGridcomponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };
    this.columnDefs = [
      {
        headerName: 'CÓDIGO',
        field: 'codigo',
        filter: true,
        width: 120,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'DESCRIPCION',
        field: 'descripcion',
        sortable: true,
        width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.editar.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.warning
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: this.DAT_BTNS.eliminar,
          colorBoton: this.DAT_BTNCSS.danger
        }
      },
    ];

    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  nuevo() {
    this.commonFormService.abrirFormularioParaGuardar(this);
    this.textBoton = this.DAT_BTNS.guardar;
    this.tituloForm = 'Guardar Modelo de Negocio';
  }

  editar({ rowData }) {
    const obj = {
      codigo: rowData.codigo,
      descripcion: rowData.descripcion,
    }
    this.formulario.setValue(obj);
    document.getElementById('buttonAbrirModal').click();
  }

  acciones(event) {
    // debugger
    if (event === this.GUARDAR) {
        this.guardar();
    } else {
      this.limpiarRegresar();
    }
  }

  limpiarRegresar() {
    this.mostrarFormulario = false;
    this.tituloCard = 'Mantenedor Modelo de Negocio';
    this.tituloForm = 'Lista De Modelo de Negocio';
  }

  /** SERVICIOS */
  getDirecciones() {
    this.listaVacia = true;
    this.loading = true;
    this._direcciones.getDirecciones().subscribe((res: any[]) => {
      this.loading = false;
      this.listaVacia = (res.length === 0) ? true : false;
      this.rowData = res;
    }, (err) => {
      this.loading = false;
      this.listaVacia = true;
      this.rowData = [];
    });
  }

   eliminar({ rowData }) {
    this._utils
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.eliminar,
        // text: `${rowData.idValorFlete}`,
        action: this.DAT_BTNS.eliminar,
        funcion: this._direcciones.deleteDirecciones(rowData.codigo.trim()),
      })
      .then((res: any) => {
        this.getDirecciones();
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });

    /*this._utils.confirmarAcyncronico(this, { title: this.DAT_MSG.eliminar, text: ``, action: this.DAT_BTNS.eliminar }, () => {
      return this._direcciones.deleteDirecciones(rowData.codigo.trim());
    }, () => {
      this.gridApi.updateRowData({ remove: this.gridApi.getSelectedRows() });
    });
  */

  }




  guardar() {
    this._utils.confirmarSincronoPromesaNormal(
      {
        title: this.DAT_MSG.guardar,
        text: '',
        action: this.DAT_BTNS.guardar,
        funcion: this._direcciones.saveDirecciones(this.formulario.value),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.limpiarRegresar();
      this.formulario.reset();
      this.getDirecciones();
    }).catch((err) => {
      console.log(err);
    });
  }

  actualizar() {
    this._utils.confirmarSincronoPromesaNormal(
      {
        title: this.DAT_MSG.actualizar,
        text: '',
        action: this.DAT_BTNS.actualizar,
        funcion: this._direcciones.updateDirecciones(this.formulario.value),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.formulario.reset();
      this.getDirecciones();
      document.getElementById('cerrarModal').click();
    }).catch((err) => {
      this._utils.mensajeErroToast(err.error.message, 5000);
    });
  }

}
